import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Create (POST)
export const getAllBlogs = createAsyncThunk('get all blogs', async (newData) => {
  const response = await $axios.get('/blogs');
  return response.data;
});

// Read (GET)
export const createBlog = createAsyncThunk('create blog', async (payload) => {
  let response = [null, null];
  try {
    const res = await $axios.post(`/blogs`, payload.data);

    response = [res.data.data, null];
    
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// GET Single Blog
export const getBlog = createAsyncThunk('get single Blog', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/blogs/${id}`);
    response = [res.data.data, null];
    
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || "Something went wrong"];
  } finally {
    return response;
  }
});

// Update (PUT or PATCH)
export const updateBlog = createAsyncThunk('update Blog', async ({ id, updatedData }) => {
  let response = [null, null];
  try {
    const res = await $axios.put(`/blogs/${id}`, updatedData);
    response = [res.data.data, null];
    
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Delete (DELETE)
export const deleteBlog = createAsyncThunk('delete Blog', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.delete(`/blogs/${id}`);
    response = [res.data, null];
    
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

export const resetAllDataBlogs = createAsyncThunk('reset all data cats', async () => {
  return 'reset all data cats';
})

// Slice
const blogSlice = createSlice({
  name: 'blogSlice',
  initialState: {
    blogs: [],
    blogData: null,
    newBlog: null,
    updatedBlog: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Get all blogs
    builder
    .addCase(getAllBlogs.pending, (state, action) => {
      state.blogs = [];
    })
    .addCase(getAllBlogs.fulfilled, (state, action) => {
        state.blogs = action.payload?.data ? action.payload.data : [];
    });

    // Get Blog
    builder
    .addCase(getBlog.pending, (state, action) => {
      state.blogData = null;
    })
    .addCase(getBlog.fulfilled, (state, action) => {
      state.blogData = action.payload;
    });

    // Update Blog
    builder
    .addCase(updateBlog.pending, (state, action) => {
      state.updatedBlog = null;
    })
    .addCase(updateBlog.fulfilled, (state, action) => {
      state.updatedBlog = action.payload;
    });

    // Create Blog
    builder
    .addCase(createBlog.pending, (state, action) => {
      state.newBlog = null;
    })
    .addCase(createBlog.fulfilled, (state, action) => {
      state.newBlog = action.payload;
    });

    // Reset all state
    builder.addCase(resetAllDataBlogs.fulfilled, (state, action) => {
      state.blogs = [];
      state.blogData = null;
      state.newBlog = null;
      state.updatedBlog = null;
    });
  },
});

export default blogSlice.reducer;
